import React from 'react';
import styles from './css/index.module.css';

const AiWardenAskPanel = ({
    question,
    onQuestionChange,
    onSubmit,
    submitting,
    intelligenceAskEnabled = false,
    accuracyMode = false,
    onAccuracyModeChange,
}) => {
    const submitLabel = submitting
        ? intelligenceAskEnabled
            ? 'Orchestrating…'
            : 'Analyzing…'
        : 'Ask AI';

    return (
        <>
            <label className={styles.aiWardenSectionLabel}>Sources</label>
            <div className={styles.aiWardenSourceToggles}>
                <label className={`${styles.aiWardenSourceToggle} ${styles.aiWardenSourceToggleDisabled}`}>
                    <input type="checkbox" checked disabled aria-label="VDR is always on" />
                    <span>VDR</span>
                </label>
                <span className={styles.aiWardenTip}>IRL and Observations are scoped via tags in the left panel.</span>
            </div>
            <label className={styles.aiWardenSectionLabel}>Accuracy</label>
            <div className={styles.aiWardenAccuracyToggleRow}>
                <label className={styles.aiWardenSourceToggle}>
                    <input
                        type="checkbox"
                        checked={Boolean(accuracyMode)}
                        onChange={e => onAccuracyModeChange?.(e.target.checked)}
                        aria-describedby="ai-warden-accuracy-helper"
                    />
                    <span>Accuracy Mode</span>
                </label>
                <p id="ai-warden-accuracy-helper" className={styles.aiWardenAccuracyHelper}>
                    Uses stricter evidence validation and may take longer.
                </p>
            </div>
            <label className={styles.aiWardenSectionLabel}>Your question</label>
            <textarea
                className={styles.aiWardenAskTextarea}
                rows={5}
                value={question}
                onChange={e => onQuestionChange(e.target.value)}
                placeholder="e.g. Are there any policies we must implement before closing?"
            />
            <div className={styles.aiWardenAskActions}>
                <button type="button" className={styles.aiWardenPrimaryBtn} onClick={onSubmit} disabled={submitting}>
                    {submitLabel}
                </button>
                <span className={styles.aiWardenTip}>Answers use only retrieved context from your selection.</span>
            </div>
        </>
    );
};

export default AiWardenAskPanel;
